// extracted by mini-css-extract-plugin
module.exports = {"text":"Speaker_text__CsC4b","image":"Speaker_image__BB19l","active":"Speaker_active__ynbJh","card":"Speaker_card__jos7F"};